import { FunctionComponent, h } from 'preact';
import { useMemo } from 'preact/hooks';
import { TaskPhase } from '@bringg/types';
import { lazy, Suspense } from 'preact/compat';
import Loading from '../../../components/loading/loading';

const Schedule = lazy(() => import('../../schedule/schedule'));
const OptInPage = lazy(() => import('../../../pages/opt-in-page/opt-in-page'));
const ErrorPage = lazy(() => import('../../../pages/error-page/error-page'));

interface Props {
	taskPhase: TaskPhase;
}

const CustomerExperienceContent: FunctionComponent<Props> = ({ taskPhase }) => {
	const content = useMemo(() => {
		switch (taskPhase) {
			case TaskPhase.SCHEDULING:
				return <Schedule />;
			case TaskPhase.SCHEDULED:
				return <OptInPage />;
			default:
				return <ErrorPage />;
		}
	}, [taskPhase]);

	return <Suspense fallback={<Loading />}>{content}</Suspense>;
};

export default CustomerExperienceContent;
